import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {AbstractControl, FormBuilder, Validators} from '@angular/forms';
import { ProfileTypeService } from '../profile-type.service';
import { ProfileType } from '../steel-profile';

@Component({
    selector: 'app-profile-type-create',
    templateUrl: './profile-type-create.component.html',
    styleUrls: ['./profile-type-create.component.css']
})

export class ProfileTypeCreateComponent implements OnInit {

  newProfileType: ProfileType;
  profileTypeForm: AbstractControl;
  families = ProfileType.getFamilies();
  @Output() updateListProfileTypes = new EventEmitter();
  @Output() hideFormProfileTypes = new EventEmitter();
  @Output() editProfileType = new EventEmitter();

  constructor(private fb: FormBuilder,
              private profileTypeService: ProfileTypeService) {

      this.profileTypeForm = this.fb.group({
          name: ['', [Validators.required]],
          family: ['', [Validators.required]]
      });
  }

  ngOnInit() {
    this.profileTypeForm.valueChanges.subscribe(values => this.changed(values));
  }

  changed(values){
    this.newProfileType = new ProfileType();
    this.newProfileType.name = values.name;
    this.newProfileType.family = values.family;
  }

  cancelCreation() {
      // this.router.navigate(['/perfiles']);
      this.profileTypeForm.reset();
      this.newProfileType = null;
      this.hideFormProfileTypes.emit();
  }

  create() {
      this.profileTypeService.create(this.newProfileType).subscribe(
          (res) => {
            // this.router.navigate(['/perfiles']);
            this.updateListProfileTypes.emit();
            this.cancelCreation();
            this.hideFormProfileTypes.emit();
          }
      );
  }

  canCreate(): boolean {
      return this.profileTypeForm.valid;
  }
}



// WEBPACK FOOTER //
// ./src/app/steel-profile/profile-type-create/profile-type-create.component.ts